<template>
    <span v-if="facturas.length">
        <download-excel class="btn btn-azul" :data="facturas" :fields="json_fields" worksheet="Recibos" :stringifyLongNum="true" :name="getfilename()"> <v-icon class="ma-0" color="white">mdi-download</v-icon> Descargar Datos en excel </download-excel>

        <v-btn depressed color="green" class="ml-4" outlined @click="descargarfacilito()">
            <v-icon dark> mdi-download </v-icon>
            Descargar Formato Facilito
        </v-btn>
    </span>
</template>

<script>
export default {
    props: {
        facturas: { type: Array, require: true },
        datosdescarga: { type: Object, require: true },
    },
    data() {
        return {
            json_fields: {
                ESPECIFICACION: "especificacion",
                "N°": "nro",
                "FECHA DE LA FACTURA": "fecha_slash",
                "N° DE LA FACTURA": "numero_factura",
                "N° DE AUTORIZACION": "numero_autorizacion",
                ESTADO: "estado",
                "NIT/CI CLIENTE": "nit_cliente",
                "NOMBRE O RAZON SOCIAL": "nombre_cliente",
                "IMPORTE TOTAL DE LA VENTA": "importe_total_venta",
                "IMPORTE ICE/IEHD/IPJ/TASAS/OTROS NO SUJETOS AL IVA": "importe_iva",
                "EXPORTACIONES Y OPERACIONES EXENTAS": "exportaciones",
                "VENTAS GRAVADAS A TASA CERO": "ventas_tasa_cero",
                SUBTOTAL: "subtotal",
                "DESCUENTOS, BONIFICACIONES Y REBAJAS SUJETAS AL IVA": "descuentos_iva",
                "IMPORTE BASE PARA DEBITO FISCAL": "importe_fiscal",
                "DEBITO FISCAL": "debito_fiscal",
                "CODIGO DE CONTROL": "codigo_control",
            },
            json_meta: [[{ key: "charset", value: "utf-8" }]],
        };
    },
    components: {},
    watch: {},
    methods: {
        descargarfacilito() {
            let csv = "data:text/csv;charset=utf-8,";
            this.facturas.forEach((x) => {
                if( !x.razon_social ) x.razon_social = x.nombre_cliente;
                x.razon_social = x.razon_social.replace(/ /g, "_");
                let nombre_cliente = x.nombre_cliente.replace(/ /g, "_").toUpperCase();
                let linea = `
                ${x.especificacion}|
                ${x.nro}|
                ${x.fecha_slash}|
                ${x.numero_factura}|
                ${x.numero_autorizacion}|
                ${x.estado.substring(0, 1)}|
                ${x.nit_cliente}|
                ${nombre_cliente}|
                ${x.importe_total_venta}|
                ${x.importe_iva}| 
                ${x.exportaciones}|
                ${x.ventas_tasa_cero}|
                ${x.subtotal}|
                ${x.descuentos_iva}|
                ${x.importe_fiscal}|
                ${x.debito_fiscal}|
                ${x.codigo_control}`;
                linea = linea.trim();
                linea = linea.replace(/ /g, "");
                linea = linea.replace(/\n/g, "");
                linea = linea.replace(/_/g, " ");
                csv += linea + "\r\n";
            });

            let encode = encodeURI(csv);
            let link = document.createElement("a");
            let filename = this.datosdescarga.filename;
            link.setAttribute("href", encode);
            link.setAttribute("download", filename + ".txt");
            document.body.appendChild(link);
            link.click();
        },
        getfilename() {
            let filename = this.datosdescarga.filename;
            return filename + ".xls";
        },
    },
    mounted() {},
};
</script>
